module.exports = __webpack_public_path__ + "static/fp_ats-e286d5df453ac8aa437886fa692e0e4e.png";